import { useQuery } from "@tanstack/react-query";
import { api, storePath } from "./api";

export type Job = {
  id: string; kind: string; status: "queued" | "running" | "succeeded" | "failed" | "cancelled";
  progress: number; total: number; result?: Record<string, unknown>; error?: string; created_at: string; finished_at?: string;
};

// useJob follows a background job until it finishes. Progress also arrives
// over the event stream (job.progress invalidates this query); polling is the fallback.
export function useJob(storeId: string | undefined, jobId: string | null | undefined) {
  return useQuery({
    queryKey: ["store", storeId, "jobs", jobId],
    enabled: !!storeId && !!jobId,
    queryFn: () => api<Job>(storePath(storeId!, `/jobs/${jobId}`)),
    refetchInterval: (q) => (q.state.data && ["succeeded", "failed", "cancelled"].includes(q.state.data.status) ? false : 1500),
  });
}

export const jobDone = (j?: Job) => !!j && ["succeeded", "failed", "cancelled"].includes(j.status);
